import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  text: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(-2),
  },
  contentWraper: { display: 'flex', gap: '12px' },
  textLinkWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
    marginBottom: theme.spacing(1),
  },
  externalLinkIcon: {
    width: '14px',
    height: '14px',
    color: theme.palette.select.light,
  },
}))
